export enum ProjectValidationFilter {
  PMD = 'PMD',
  PMC = 'PMC',
  NONE = 'NONE',
}

export const projectValidationFilterToLabel: { [value: string]: string } = {
  [ProjectValidationFilter.PMD]: 'PMD Validation in Place',
  [ProjectValidationFilter.PMC]: 'PMC Validation in Place',
  [ProjectValidationFilter.NONE]: 'No Validation in Place',
};
